import { connect } from 'react-redux';
import { resetAbort } from 'common/publish-steps/containers/publish-steps-actions';
import Gantt from '../components/gantt';
import {
  setView,
  setGanttDimensions,
  setViewDimensions,
  setLanesInfo,
  setLanesData,
  fetchBoardData,
  fetchViewData,
  updateFilters,
  setCurrentPage,
  resetBoardData,
  resetOpenPlanningAndView,
  setViewInternal,
  setDateReference,
} from './gantt-actions';

const mapStateToProps = state => ({
  view: state.gantt.view,
  lanesInfo: state.gantt.lanesInfo,
  lanesData: state.gantt.lanesData,
  boardData: state.gantt.boardData,
  partiallyExecuted: state.gantt.partiallyExecuted,
  viewData: state.gantt.viewData,
  dateReference: state.gantt.dateReference,
  isLoadingViewData: state.gantt.isLoadingViewData,
  isLoadingBoardData: state.gantt.isLoadingBoardData,
  menuVisible: state.header.menuVisible,
  error: state.gantt.error,
  activeFilters: state.gantt.activeFilters,
  activeView: state.gantt.activeView,
  activeSort: state.gantt.activeSort,
  currentPage: state.gantt.currentPage,
  isLoadingBlockData: state.gantt.isLoadingBlockData,
  planningToPublishMessage: state.gantt.planningToPublishMessage,
  planningAndViewToOpen: state.gantt.planningAndViewToOpen,
  publishAllSuccessMessage: state.gantt.publishAllSuccessMessage,
  abortFailure: state.currentStatus.abortFailure,
  activePeriod: state.gantt.view,
  forceFetchGanttData: state.gantt.forceFetchGanttData,
});

const mapDispatchToProps = {
  setView,
  setGanttDimensions,
  setViewDimensions,
  setLanesInfo,
  setLanesData,
  fetchBoardData,
  fetchViewData,
  updateFilters,
  setCurrentPage,
  resetAbort,
  resetBoardData,
  resetOpenPlanningAndView,
  setViewInternal,
  setDateReference,
};

export default connect(mapStateToProps, mapDispatchToProps)(Gantt);
